import { BodyBox } from '@lbcamden/lib-react';
import { formatDMY, formatDMYWithTime, formatYesNo } from '@lbcamden/shared-utils';
import { FunctionComponent } from 'react';
import { useParams } from 'react-router';

import {
  useArrearsArrangement,
  useProperty,
  useReferenceListDisplayValue,
} from '~/client/hooks/storeHooks';
import { formatGBP } from '~/client/utils/currency';
import { getPropertyBreadcrumbs } from '~/client/utils/navigation';

import { ItemDetails } from '../../common/ItemDetails';
import { PageTitle } from '../../common/PageTitle';
import { DirectoryUserInfo } from '../../shared/DirectoryUserInfo';
import { PageBreadcrumbs } from '../../shared/PageBreadcrumbs';
import { LoadInNotFoundPage } from '../LoadInNotFoundPage';

export const ArrearsArrangementPage: FunctionComponent = () => {
  const { propertyId: propertyIdParam, arrangementId: arrangementIdParam } = useParams();
  const propertyId = parseInt(propertyIdParam!);
  const arrangementId = parseInt(arrangementIdParam!);

  const property = useProperty(propertyId);
  const referenceListDisplayValue = useReferenceListDisplayValue();
  const arrangement = useArrearsArrangement(arrangementId);

  if (!property || !arrangement) {
    return <LoadInNotFoundPage />;
  }

  const pageTitle = `Arrangement ${arrangementId}`;

  return (
    <BodyBox>
      <PageTitle title={pageTitle} />
      <PageBreadcrumbs links={[...getPropertyBreadcrumbs(property), { name: pageTitle }]} />
      <ItemDetails
        titleLabel="Arrangement"
        title={arrangement.actionDescription}
        sections={[
          {
            title: 'Arrangement details',
            details: [
              ['Arrangement reference number', arrangement.arrangementId],
              ['Balance', formatGBP(arrangement.balance)],
              ['Created', formatDMYWithTime(arrangement.created)],
              // oxlint-disable-next-line react/jsx-key -- prop tuple, not rendered children
              ['Created by', <DirectoryUserInfo camdenAccountName={arrangement.createdBy} />],
              ['Start date', formatDMY(arrangement.startDate)],
              ['Amount', formatGBP(arrangement.amount)],
              [
                'Payment frequency',
                `Every ${arrangement.intervalPeriod} ${referenceListDisplayValue(
                  'PERIODS',
                  arrangement.intervalUnits,
                ).replace(/s$/, arrangement.intervalPeriod === 1 ? '' : 's')}`,
              ],
              ['First direct debit taken', formatYesNo(arrangement.hasTakenFirstDd)],
            ],
          },
        ]}
      />
    </BodyBox>
  );
};
